// chatbot constants

export const RANDOM_SEPARATOR = "auo0os6"